
import config from '../config.json'
const isEncryptionEnabled = process.env.REACT_APP_IS_ENCRYPTION_ENABLED;

const demo = config.demo;
// export const BASE_URL = (demo)? "https://aointakeuatapi.agingoptions.com": "https://aointakeapi-hcfhhdfmhfgtctdd.westus2-01.azurewebsites.net";

const uatBaseURL = isEncryptionEnabled === "true" ? "https://aointakeuatapi-apim.azure-api.net/LPL" : "https://aointakeuatapi.agingoptions.com";
const prodBaseURL = isEncryptionEnabled ==="true" ? "https://aointakeapi-apim.azure-api.net/LPL" : "https://aointakeapi-hcfhhdfmhfgtctdd.westus2-01.azurewebsites.net";










export const BASE_URL = (demo)? uatBaseURL : prodBaseURL;

// Base URL used ONLY for file uploads (multipart/form-data).
// The APIM gateway (...azure-api.net/LPL) rejects multipart uploads with 415,
// so file uploads must use the older non-APIM host.
export const FILE_UPLOAD_BASE_URL = (demo)
  ? "https://aointakeuatapi.agingoptions.com"
  : "https://aointakeapi-hcfhhdfmhfgtctdd.westus2-01.azurewebsites.net";

// Base URL used specifically for GET requests (non-encrypted host)
// export const GET_BASE_URL = (demo) ? "https://aointakeuatapi.azurewebsites.net" : "https://aointakeapi-hcfhhdfmhfgtctdd.westus2-01.azurewebsites.net";

// export const BASE_URL = (config.demo)? "https://aointakeuatapi.azurewebsites.net": "https://aointakeapi.azurewebsites.net";
// export const EVENTCOUNTERURL =  (config.demo)?"https://aoeventcounteruat.azurewebsites.net/": "https://aoeventcounter.azurewebsites.net/";
// export const AOLOGINBASEURL =  (config.demo)?"https://aologinuat.azurewebsites.net": "https://aologin.azurewebsites.net/";
// export const EVENTFUNNELURL=(config.demo)?'https://eventuat.azurewebsites.net':'https://eventdev.azurewebsites.net';
// export const BASE_URL = (config.demo)? "https://aointakeuatapi.azurewebsites.net": "https://aointakeapi-hcfhhdfmhfgtctdd.westus2-01.azurewebsites.net";
export const EVENTCOUNTERURL =  (config.demo)?"https://aoeventcounteruat.agingoptions.com/": "https://Event.counter.agingoptions.com/";
export const AOLOGINBASEURL =  (config.demo)?"https://aologinuat.agingoptions.com": "https://Unilogin.agingoptions.com";
export const EVENTFUNNELURL=(config.demo)?'https://eventuat.agingoptions.com':'https://events.agingoptions.com';
export const stripePaymentConfirmationUrl=(config.demo) ?'https://staging2.agingoptionsacademy.com//wp-json/custom-api/v1/apply-coupon':'https://agingoptionsacademy.com/wp-json/custom-api/v1/apply-coupon';

export const intakeBaseUrl = (config?.demo) ? 'https://aointakeformuat.agingoptions.com/' : 'https://member.intake.agingoptions.com/';
export const AoAgenturl = (config.demo) ? 'https://aoagentuat.agingoptions.com/' : 'https://agent.agingoptions.com/';
export const AoAcaddemyUrl = (config.demo) ? "https://academy.nsplindia.co.in" : "https://agingoptionsacademy.com/"
export const EventBaseUrl =(config.demo)?"https://eventuat.agingoptions.com/":"https://events.agingoptions.com/";
export const CounterBaseUrl =  (config.demo)?"https://aoeventcounteruat.agingoptions.com/": "https://Event.counter.agingoptions.com/";
export const CounterMobileBaseUrl = (config.demo)?"https://aoeventcountermobileuat.agingoptions.com/": "https://event.mcounter.agingoptions.com/";
export const AoAdminBaseUrl = (config.demo)?'https://Aoadminuat.agingoptions.com/': 'https://AOAdmin.agingoptions.com/';;
export const AoPartnerBaseUrl =(config.demo)?"https://aopartneruat.agingoptions.com/": "https://partner.admin.agingoptions.com/";;
export const IntakeEntryBaseUrl =(config.demo)?"https://intakeentryformuat.azurewebsites.net/": "https://intakeentryform.azurewebsites.net/";;

export const CRM_BASEURL = (config.demo) ? "https://crmuat.agingoptions.com" : "https://crm.agingoptions.com";


let AoUrl = {
   getUserListByEmailId: "/api/Account/GetLoginUserDetails",
   getUserDetailsByUserEmailId:'/api/Account/GetUserDetailByEmailId',
   putClientHandOff: "/api/Member/ClientHandOff",
   getFeedbackPriority:"/api/FeedbackPriority/GetFeedbackPriority",
   putUserName: "/api/Account/UpdateUserName",
   getModuleType: "/api/ModuleType/GetModuleType",
   getFeedbackStatus:"/api/FeedbackStatus/GetFeedbackStatus",
   getFeedbackType:"/api/FeedbackType/GetFeedbackType",
   updateFeedback:"/api/Feedback/update-feedback",
   // ........................................
   postSubtenantDetailPath: 'api/Subtenant/add-subtenant/',
   putSubtenantDetailPath: 'api/Subtenant/update-subtenant/',
   getSubtenantCategoryPath: 'api/SubtenantCategory/GetSubtenantCategoryList/true',
   // ..................1.....................
   postSpeakerResgisterUser: '/api/User/RegisterUser',
   // .......
   postfileuploadspeaker: '/api/FileUpload/uploadUserDocuments',
   fileUploadPath: "/api/FileUpload/uploadUserDocuments",
   postFeedback: "/api/Feedback/add-feedback",
   sendPostEmailCC:'/api/EmailComm/SendEmailWithCCAsync',
   sendMailFeedBack:'/api/EmailComm/SendEmailToMultipleNAttachmentAsync',
   // ..................
   postspeakerupsertuser: '/api/SpeakerUser/upsert-SpeakerUser',
   seminarTypeUrl: 'api/SeminarType/get-SeminarTypes/',
   // GetSubtenantCategoryListPath: 'api/SubtenantCategory/GetSubtenantCategoryList/true',
   getSeminarDetailsVenueData: '/api/Venue/getVenue',
   postSubtenantDetails: '/api/Subtenant/get-subtenant-details',
   getCoOrdinatorUserList: '/api/User/getUserList',
   postAddressData: 'api/Address/add-address',
   postVenueData: 'api/Venue/upsertVenueBySubtenantId',
   getCountryListPath: + "/api/Country",
   postSeminarPublisherApi: 'api/SeminarPublisher/upsertSeminar',

   getSpeakerUserDetailsPath: 'api/User/getUserList',
   postCoordinatorAdd: 'api/Account/add-User',
   getPhoneCodePath: '/api/Country/GetRegistrationEnableCountry',
   getAddressIdPath: '/api/Address/get-address',
   postSpeakerList: 'api/SpeakerUser/get-SpeakerUser',
   getUserListpath: 'api/User/getUserList',
   getUserUserSubs: 'api/UserAuthSubs',
   getGenders: '/api/Genders',
   getCitizenshipTypePath: 'api/CitizenshipType',
   getcountrycodepath: '/api/Country/GetRegistrationEnableCountry',
   getContactTypePath: 'api/ContactType',
   // ..................................................................................
   getAthenticatePath: '/api/2/User/AuthenticateLoggedInUser',
   getSubtenantDetailPath: 'api/Subtenant/get-subtenant-details',
   postAddUserPath: 'api/Account/add-User',
   getSubtenantPlanner: 'api/User/getUserList',
   postPlannerCalendar: 'api/PlannerCalendar/upsertPlannerCalendar',
   getseminar: '/api/SeminarPublisher/getSeminar/',
   getseminarNew: '/api/SeminarPublisher/getSeminarV2/',
   upsertSeminar: 'api/SeminarPublisher/updateSeminarStatus',
   postsubtenantcreateUser: '/api/User/CreateUser/',
   postsubtenantcreateUserNew: '/api/User/AddUser/',
   postaddressbyuserid: '/api/Address/add-address-by-userid',
   postsubtenantusermemberupdate: '/api/Member/update-member-by-id/',
   postAnsycRole: 'api/UserRole/AddRoleAsync/',
   getUserListByRoleId: '/api/User/getUserListByRoleId/',
   getUserLegalCompensation: '/api/LegalCompensation/getCompModelType/',
   getUserCompensationUserDetails: '/api/LegalCompensation/',
   upsertLegalCompensataion: '/api/LegalCompensation/upsertLegalCompensation',
   postRoleIdAPI: '/api/UserRole/AddRoleAsync/',
   getAddressAPI: '/api/Address/get-address-by-userid/',
   getContactAPi: '/api/Contact/get-contact-by-userid/',
   getMemberAPI: '/api/Member/',
   getAllUserRoleIdAPi: '/api/UserRoles/getRoles',
   getUserRoleAPI: '/api/UserRole/GetUserRole',
   putAPIForContact: "/api/Contact/update-contact-by-userid/",
   postAPIForContact: "/api/Contact/add-contact-by-userid/",
   putAPIForAddress: "/api/Address/update-address",
   putAPIForMember: "/api/Member/update-member-by-id",
   putRoleIdAPI: '/api/UserRole/UpdateRoleAsync/',
   postAcademyUser :"/api/User/CreateAcademyUser",
   sendUserActivationLink: '/api/UserActivation/SendUserActivationLink',
   getExpirydatetime:'/api/UserValidity/GetUserValidity',
   upGradeValidity : '/api/UserValidity/UpgradeUserValidity',
   getContactTypeCat : '/api/SubContactType',
   upsertStaffClient:'/api/2/User/UpsertStaffAsClientAccount',
   deletePartnerUserAPI: '/api/User/delete-User/',
   inActivePartnerUserAPI: '/api/User/inactive-User/',
   GetStaffAsClientAccount:'/api/2/User/GetStaffAsClientAccount',
   getMembersByParalegalId:'/api/2/Paralegal/getMembersByParalegalId',
   postAddUser: "/api/User/AddUser/",
   postbulkfile: '/api/2/user/createusers/',

   // //classroom
   // postuploadUserDocumant:'/api/FileUpload/uploadUserDocuments'

   //sumit
   getCommonChannelPath: '/api/CommChannel/GetCommChannel/',
   getUSerRolesAdminPath: '/api/UserRoles/getRoles/',
   getOccurrencePath: '/api/Occurrence/GetOccurrence/',
   getOccurrencePath2: 'api/Occurrence/GetDisplayScreen?IsActive=',

   getEmailTemplatesPath: '/api/EmailTemplates/GetEmailTemplates/',
   getTextTemplatesPath: '/api/TextTemplates/GetTextTemplates/',
   getTextTemplatesConstantPath: '/api/DisplayContent/GetDisplayContent?SubtenantId',

   postUpsertOccurrencePath: '/api/Occurrence/upsertOccurrence/',
   postEmailTemplatesPath: '/api/EmailTemplates/AddEmailTemplates/',
   postTextTemplatesPath: '/api/TextTemplates/UpsertTextTemplates/',
   postUpsertCommMediumPath: '/api/CommMedium/UpsertCommMedium/',
   upsertDisplayContentPath: '/api/DisplayContent/UpsertDisplayContent/',
   GetCommMediumPath: '/api/CommMedium/GetCommMedium/',
   GetCommMediumPath2: 'api/CommMedium/GetCommMediumV2',
   putUpdateEmailTemplatesPath: '/api/EmailTemplates/UpdateEmailTemplates/',
    atTheRateGetOccurrenceDataPath:'/api/OccurrenceData/GetOccurrenceData',
   //sumit

   getEmailTemplatesUrl: '/api/EmailTemplates/GetEmailTemplates',
   postSendEmailCommUrl: '/api/EmailComm/SendEmailComm',

   getEmailTemplatesUrl: '/api/EmailTemplates/GetEmailTemplates',
   getActivationUrl: '/api/UserActivation/GetUserActivationLink',
   postSendEmailCommUrl: '/api/EmailComm/SendEmailComm',

   // //Subscription
   // postIndServicePath: '/api/IndService/Upsert-IndService',
   // getIndService: '/api/IndService/Get-IndService',
   // postGrpService: '/api/GrpService/upsertGrpService',
   // getGrpService: '/api/GrpService/getGrpService',
   // postSaleAbleSKUPath: '/api/SaleableSKU/UpsertSaleableSKU',
   // getSaleAbleSKUPath: '/api/SaleableSKU/GetSaleableSKU',

   //Subscription
   postIndServicePath: '/api/IndService/Upsert-IndService',
   getIndService: '/api/IndService/Get-IndService',
   postGrpService: '/api/GrpService/upsertGrpService',
   getGrpService: '/api/GrpService/getGrpService',
   postSaleAbleSKUPath: '/api/SaleableSKU/UpsertSaleableSKU',
   getSaleAbleSKUPath: '/api/SaleableSKU/GetSaleableSKU',

   //Rate Card
   postToAddRateCardPath: '/api/RateCard/UpsertRateCard',
   postAppSubtForRateCardPath: '/api/ApplicableSubtentantSubscriptions/UpsertApplicableSubtentantSubscriptions',
   getRateCardPath: '/api/RateCard/GetRateCard',
   getpostPlannerDetails: '/api/PlannerCalendar/GetPlannerCalendarDetails',
   upsertPlannerDetails: '/api/PlannerCalendar/upsertPlannerCalendar',

   // file cabinet
   getFileCabinetType: 'api/FileCabinet/GetFileCabinetList',
   postFileDocumentCabinetById: '/api/FileCabinet/GetUserDocsByFileCabinet',
   filecabinetPreparebyUrl: 'api/FileCabinet/PreparedBy/',
   filecabinetfilestatus: '/api/FileCabinet/FileStatus',
   filecabinetdocumenturl: '/api/UserFileCabinet/Documents',
   getUserInvitation: `/api/UserInvitation/getUserInvitation`,
   // getProfessionalListv2:'/api/2/ProfessionalUser/getProfessionalSuggestionsV2',
   getProfessionalListv2:'api/2/ProfessionalUser/getProfessionalSuggestionsV3',
   postProfessionalListv2:'/api/2/ProfessionalUser/UpdateProUserPriority',
   postAddmember:'/api/Member/add-member',


   //Rate Card
   postToAddRateCardPath : '/api/RateCard/UpsertRateCard',
   // postAppSubtForRateCardPath : '/api/ApplicableSubtentantSubscriptions/UpsertApplicableSubtentantSubscriptions',
   postAppSubtForRateCardPath : '/api/ApplicableSubsModel/UpsertApplicableSubsModel',
   getRateCardPath : '/api/RateCard/GetRateCard',
   getpostPlannerDetails:'/api/PlannerCalendar/GetPlannerCalendarDetails',
   upsertPlannerDetails:'/api/PlannerCalendar/upsertPlannerCalendar',
   getAvailableRateCardName : '/api/RateCard/IsRateCardNameAvailable',
   getSubsModelPath : '/api/SubsModel/GetSubsModel',

   //Feedback
   getFeedback:'/api/Feedback/get-feedback',

   //  new file cabinet api --------------------------------------------------
   getMainCabinet: '/api/2/FileCabinet/GetMainCabinet',
   upsertMainCabinet: '/api/2/FileCabinet/UpsertMainCabinet',
   upsertCabinetCategoryType: '/api/2/FileCabinet/UpsertFileCategoryType',
   upsertCabinetFolder: '/api/2/FileCabinet/UpsertFileCabinetFolder',
   getFileCategoryTypeList: '/api/2/FileCabinet/GetFileCategoryTypeList',
   addFileCabinetFolder: "/api/2/FileCabinet/AddFileCabinetFolder",
   deleteFileCabinetFolder:'/api/2/FileCabinet/DeleteFolder/',
   getSubtenantDetails: '/api/Subtenant/get-subtenant-details',
   getUserList: '/api/User/getUserList',
   fileBelongsTo: '/api/FileCabinet/FileBelongsTo',
   getFileTypeByCategory: '/api/2/FileCabinet/GetFileTypeList',
   upsertFileTypeByCategory: '/api/2/FileCabinet/UpsertFileType',
   postUploadUserDocument: '/api/FileUpload/uploadUserDocuments',
   addUserFileCabinet: '/api/2/UserFileCabinet/Add',
   getUserFileCabinetFile: '/api/2/UserFileCabinet/Documents/',
   getFileForView: '/api/FileUpload/downloadUserDocuments/',
   deleteFileCabinetFileByFileId: '/api/FileCabinet/DeleteFilebyFileId',
   sendMailToClientOnclosingFeedbackStatus:'/api/EmailComm/SendEmailWithCCnBccAsync',
   postLogUserout: BASE_URL + '/api/User/LogoutUser/',
   postModuleConnecturl:BASE_URL+'/api/ModuleConnection',
   // Get User IPv4
   getIPv4: "/api/CEAuthorization/get-ip",



   getSubscriptionList: 'api/subscription/',
   getSubscriptionplanList: 'api/SubscriptionPlan/GetSubscriptionPlanDropDownList',
   upsertSubsPlanSKUMap:'api/SubsPlanSKUMap/upsertSubsPlanSKUMap',
   getSubsPlanSKUMap:'api/SubsPlanSKUMap/',
   getSubscriptionPlansBySubsPlanId:'api/SubscriptionPlan/GetSubscriptionPlansBySubsPlanId',
   getSubtenantAgreement:'/api/SubtenantAgreement/',
   upsertAgreementdata:'/api/SubtenantAgreement/upsertSubtenantAgreement',
   getratecardlist:'/api/Subscription/Details/',
   getFinancecalculation:'/api/LegalCompensation/GetFinanceCalculation',
   getAttorneyRecords:'/api/LegalCompensation/GetAttorneyRecords',
   getUserLegalStaff:'api/UserLegalStaff/GetUserLegalStaff',
   getOrderDetailbySubtenantId:'/api/Records/GetOrderDetailbySubtenantId',
   getClientsEmailApi:"/api/Account/GetUserDetailByEmailId",

   // Agent Workflow
   upsertAgentCategory: '/api/2/AgentWorkflow/UpsertCategoriesAsync',
   getAgentCategories: '/api/2/AgentWorkflow/getAgentCategories',
   getAgentNodeType: '/api/2/AgentWorkflow/getAgentNodeType',
   upsertAgentStep: '/api/2/AgentWorkflow/UpsertStepsAsync',
   getStepsByCategoryId: '/api/2/AgentWorkflow/getStepsByNodeIdOrCategoryId',
   getAgentWorkflowApiLog: '/api/2/AgentWorkflow/getAgentWorkflowApiLog',
   getAgentScreenTemplates: '/api/2/AgentWorkflow/getAgentScreenTemplates',
   getProfessionalSecDesc: '/api/ProfessionalSecDesc',
   getProfessionalSerType: '/api/ProfessionalType',
   upsertAgentQuestion: '/api/2/AgentWorkflow/UpsertQuestionAsync',
   getQuestionsByNodeId: '/api/2/AgentWorkflow/getQuestionsByNodeId',
   getQuestionsByCategoryId: '/api/2/AgentWorkflow/getQuestionsByCategoryId',
   upsertAgentOption: '/api/2/AgentWorkflow/UpsertOptionsAsync',
   getOptionsByQuestionId: '/api/2/AgentWorkflow/getOptionsByQuestionId',
   getOptionsByCategoryId: '/api/2/AgentWorkflow/getOptionsByCategoryId',
   upsertFormField: '/api/2/AgentWorkflow/UpsertFormFieldsAsync',
   getFormFields: '/api/2/AgentWorkflow/getFormFields',
   upsertForm: '/api/2/AgentWorkflow/UpsertFormAsync',
   getFormByNodeId: '/api/2/AgentWorkflow/getFormByNodeId',
   upsertInfo: '/api/2/AgentWorkflow/UpsertInfoAsync',
   getInfoByNodeId: '/api/2/AgentWorkflow/getInfoByNodeId',
   upsertAction: '/api/2/AgentWorkflow/UpsertActionAsync',
   getActionByNodeId: '/api/2/AgentWorkflow/getActionByNodeId',
   deleteCategoryByCategoryId: '/api/2/AgentWorkflow/deleteCategoryByCategoryId',
   deleteNodeByNodeId: '/api/2/AgentWorkflow/deleteNodeByNodeId',
   deleteWorkflowEntity: '/api/2/AgentWorkflow/deleteWorkflowEntity',
   deleteFieldByFieldId: '/api/2/AgentWorkflow/deleteFieldbyFieldId',
   updateAgentCategoryDisplay: '/api/2/AgentWorkflow/updateAgentCategoryDisplay',
   getCategoryHierarchyPdf: '/api/2/AgentWorkflow/getCategoryHierarchyPdf',
   getUserServicePlan: '/api/UserServicePlan/Get-User-Service-Plan-Values',


   getProfessionalCategories:'/api/ProfessionalCategories/GetProfessionalCategories',
   getDocTypeDropdown: '/api/GenerateDocument/get-docType-dropdown',
   getProfessionalType:"/api/ProfessionalType?proSerDescId",
   getProfessionalSubType:"/api/ProfessionalSubType",
   postOthersData:"/api/Others/add-others",
   postOthersMapData:"/api/MemberOthersMap/add-member-othersmap",
   otherContactType:'/api/ContactWithOther/add-contactwithother-by-userid',
   postAddmemberProfess:"/api/2/ProfessionalUser/UpsertProUserMap",

   // document management
   getDocumentTemplateTree: '/api/GenerateDocument/get-document-template-tree',
   previewEditDocTool: '/api/PreviewEditDocTool/PreviewEditDocTool',
   postCommediumV2: "/api/CommMedium/GetCommMediumV2",
   sentEmailWithAsyncCcBc:'/api/EmailComm/SendEmailWithCCnBccAsync',
   getEmailHistory:"/api/CommMedium/GetEmailHistory",
   saveDocTool: '/api/PreviewEditDocTool/Save',
   resetDocumentTemplate: '/api/GenerateDocument/ResetDocumentTemplateContent',
   getDocumentVersions: '/api/GenerateDocument/get-document-template-versions',
}

export default AoUrl;

